import { useStore, createStore } from 'zustand';

interface Current2FAPanelStore {
    activeRoute: Configure2FAPanelRoutes | undefined;
    userPassword: string;
    open2FAPanel: (route: Configure2FAPanelRoutes, password: string) => void;
    change2FARoute: (route: Configure2FAPanelRoutes) => void;
    close2FAPanel: () => void;
}

export enum Configure2FAPanelRoutes {
    selectMethod = 'selectMethod',
    deviceConfig = 'deviceConfig',
    emailConfig = 'emailConfig',
}

const twoFactorStore = createStore<Current2FAPanelStore>((set) => ({
    userPassword: '',
    activeRoute: undefined,
    open2FAPanel: (route, password) => set({ userPassword: password, activeRoute: route }),
    change2FARoute: (route) => set({ activeRoute: route }),
    close2FAPanel: () => set({ userPassword: '', activeRoute: undefined }),
}));

export function useConfigure2FAPanel() {
    return useStore(twoFactorStore);
}
